import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'El centro de costo es la unidad contable a la que se imputan los gastos de cada equipo.',
    'Usá la misma nomenclatura que maneja administración, así los informes se pueden conciliar sin traducciones.',
    'Un equipo puede cambiar de centro de costo si se reasigna: el histórico anterior no se modifica.',
  ],
  nextSteps: [
    'Asignar el centro de costo a cada equipo desde su ficha.',
    'Consultar el informe de costos por centro de costo para ver el gasto acumulado de cada uno.',
    'Los centro de costo pueden indicarse en reparaciones o mantenimientos para asignar los gastos correctamente. Se toma por defecto el centro de costo asociado a la obra del equipo, pero puede modificarse en cada caso.',
  ],
};

const ConfiguracionCentrosCosto = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="centroscosto"
      titulo="Centros de Costo"
      descripcion="Gestión de centros de costo operacionales"
      icon="fas fa-building"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionCentrosCosto;